module.exports = __webpack_public_path__ + "img/d1-active.5105819b.png";